/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_DisclaimerInputs */

const en_site_disclaimer = /** @type {(inputs: Site_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep visits as BystepBot, respects robots.txt, reads at most 12 pages without logging in, and masks emails and phone numbers. Screenshots are kept for 7 days.`)
};

const id_site_disclaimer = /** @type {(inputs: Site_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep berkunjung sebagai BystepBot, mematuhi robots.txt, membaca maksimal 12 halaman tanpa login, dan menyamarkan email/nomor telepon. Tangkapan layar disimpan 7 hari.`)
};

/**
* | output |
* | --- |
* | "Bystep visits as BystepBot, respects robots.txt, reads at most 12 pages without logging in, and masks emails and phone numbers. Screenshots are kept for 7 days." |
*
* @param {Site_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_disclaimer = /** @type {((inputs?: Site_DisclaimerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_DisclaimerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_disclaimer(inputs)
	return en_site_disclaimer(inputs)
});